import { render, staticRenderFns } from "./RunnitManageAccessDialog.vue?vue&type=template&id=c515fe8a&scoped=true"
import script from "./RunnitManageAccessDialog.vue?vue&type=script&lang=ts"
export * from "./RunnitManageAccessDialog.vue?vue&type=script&lang=ts"
import style0 from "./RunnitManageAccessDialog.vue?vue&type=style&index=0&id=c515fe8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c515fe8a",
  null
  
)

export default component.exports